module.exports = __webpack_public_path__ + "static/media/storage.14aff3ba.svg";